import classNames from "classnames";
import i18next from "i18next";
import { useDispatch, useSelector } from "react-redux";

import { setFilterParams } from "../../../store/resultFiltersSlice";

import FilterGroupComponent from "../FilterGroupComponent";

import { ButtonsBlock, CombinationButton } from "./style";

/* Фильтр «Комбинация авиакомпаний» — по флагу vtrip рекомендации (составной перелёт:
   отдельные билеты разных АК, возврат/обмен независимы). Устроен как фильтр багажа. */
const FilterAirlineCombinationComponent = () => {
  const { t } = i18next;
  const {
    filterParams: { airlineCombination },
  } = useSelector(state => state.resultFilters);
  const { withCombination = false, withoutCombination = false } = airlineCombination?.values ?? {};
  const dispatch = useDispatch();

  const handleChange = filters => {
    dispatch(
      setFilterParams({
        type: "airlineCombination",
        values: {
          isActive: filters.withCombination || filters.withoutCombination,
          values: filters,
        },
      })
    );
  };

  const handleChangeWith = () => {
    if (withCombination) {
      handleChange({ withCombination: false, withoutCombination });
    } else {
      handleChange({ withCombination: true, withoutCombination: false });
    }
  };

  const handleChangeWithout = () => {
    if (withoutCombination) {
      handleChange({ withoutCombination: false, withCombination });
    } else {
      handleChange({ withoutCombination: true, withCombination: false });
    }
  };

  return (
    <FilterGroupComponent title={t("airline_combination")} isOpenable={false}>
      <ButtonsBlock>
        <CombinationButton className={classNames({ active: withCombination })} onClick={handleChangeWith}>
          {t("with_airline_combination")}
        </CombinationButton>
        <CombinationButton className={classNames({ active: withoutCombination })} onClick={handleChangeWithout}>
          {t("without_airline_combination")}
        </CombinationButton>
      </ButtonsBlock>
    </FilterGroupComponent>
  );
};

export default FilterAirlineCombinationComponent;
